



































import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { productGetters } from '@vsf-enterprise/commercetools';
import type { ProductVariantExtended } from '~/types/product/ProductVariantExtended';
import Button from '~/components/atoms/Buttons/Button/Button.vue';
import ProductFinalPrice from '~/components/molecules/Product/ProductFinalPrice/ProductFinalPrice.vue';
import ReviewsStars from '~/components/atoms/ReviewsStars.vue';
import { useProductPrice } from '~/composables';

export default defineComponent({
  name: 'ComparisonProductDetails',
  components: {
    Button,
    ReviewsStars,
    ProductFinalPrice,
  },
  props: {
    product: {
      type: Object as PropType<ProductVariantExtended>,
      required: true,
    },
    currentSku: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { product } = toRefs(props);
    const { getPriceInformation } = useProductPrice();

    const { finalPrice, discountedPrice } = getPriceInformation(product);

    const isDiscounted = computed<boolean>(() => !!discountedPrice?.value);
    const isCurrentSku = computed<boolean>(() => props.product.sku === props.currentSku);
    const averageRating = computed<number>(() => productGetters.getAverageRating(props.product));
    const ratingCount = computed<number>(() => productGetters.getTotalReviews(props.product));

    return {
      finalPrice,
      isDiscounted,
      isCurrentSku,
      averageRating,
      ratingCount,
    };
  },
});

